import './style.scss';

export const StatusCountPanelContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="status-count-panel-container">{children}</div>;
};
